import axios from 'axios';
import { API_BASE_URL } from '../../constants';
import { rememberEntitlementFetch } from './entitlementRefresh';

// Action types
export const FETCH_ENTITLEMENT_REQUEST = 'FETCH_ENTITLEMENT_REQUEST';
export const FETCH_ENTITLEMENT_SUCCESS = 'FETCH_ENTITLEMENT_SUCCESS';
export const FETCH_ENTITLEMENT_FAILURE = 'FETCH_ENTITLEMENT_FAILURE';
export const UPDATE_ENTITLEMENT = 'UPDATE_ENTITLEMENT';
export const CLEAR_ENTITLEMENT = 'CLEAR_ENTITLEMENT';

// Fetch user's current entitlement. The answer is the effective one: an
// athlete whose team's coach is on a paid plan is athlete_premium, with
// ownEntitlement, entitlementSource and coverage beside it.
export const fetchEntitlement = () => async (dispatch, getState) => {
  // Kept so a team link made outside a component refreshes this store
  // (entitlementRefresh.refreshEntitlement).
  rememberEntitlementFetch(() => dispatch(fetchEntitlement()));
  dispatch({ type: FETCH_ENTITLEMENT_REQUEST });

  try {
    const { auth } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    };

    const response = await axios.get(`${API_BASE_URL}/entitlement/`, config);

    dispatch({
      type: FETCH_ENTITLEMENT_SUCCESS,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    dispatch({
      type: FETCH_ENTITLEMENT_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch entitlement',
    });
    throw error;
  }
};

// Update entitlement in store (called after subscription changes)
export const updateEntitlement = (entitlementData) => ({
  type: UPDATE_ENTITLEMENT,
  payload: entitlementData,
});

// Clear entitlement on logout
export const clearEntitlement = () => ({
  type: CLEAR_ENTITLEMENT,
});
